document.addEventListener('DOMContentLoaded', () => {
  addSliderEventListender();
});
const addSliderEventListender = () => {
  const standardPrevButton = document.getElementById('standard-slider-prev');
  const standardNextButton = document.getElementById('standard-slider-next');

  const standardSlider = document.getElementsByClassName('nik-standard-slider-inner')[0];
  const slidesWidth = document.getElementsByClassName('nik-standard-slider-slide')[0].offsetWidth;

  standardPrevButton.addEventListener('click', () => {
    console.log('standardSlider', standardSlider);
    console.log('slidesWidth', slidesWidth);
    standardSlider.scrollBy({
      left: -slidesWidth,
      behavior: 'smooth',
    });
  });
  standardNextButton.addEventListener('click', () => {
    console.log('standardSlider', standardSlider);
    console.log('slidesWidth', slidesWidth);
    standardSlider.scrollBy({
      left: slidesWidth,
      behavior: 'smooth',
    });
  });

  const slides = document.getElementsByClassName('nik-standard-slider-slide');
  const slidesArray = Array.from(slides);
  slidesArray.forEach((slide) => {
    slide.addEventListener('touchend', (e) => {
      const el = e.target;
      setTimeout(() => {
        const activeSlideIndex = slidesArray.findIndex((slide) => {
          const { left, right } = slide.getBoundingClientRect();
          return left < el.width / 2 && right > el.width / 2;
        });
        setIndexDot(activeSlideIndex);
      }, 300);
    });
  });

  const setIndexDot = (activeSlideIndex) => {
    const sliderDots = document.querySelectorAll('.nik-standard-slider .dots .dot');
    const sliderDotsArray = Array.from(sliderDots);
    sliderDotsArray.forEach((dot, index) => {
      if (index === activeSlideIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  };
};
